import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Input, Button} from 'react-bootstrap'
import {clearHistory} from '../../core/redux/router'
import {infoStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import Box from '../../core/components/Box'
import Icon from '../../core/components/Icon'
import {RESET_PASSWORD_CMD_UPDATED, sendResetPasswordCmd} from '../actions'
import {ResetPasswordCmd, createValidator} from '../models'
import i18n from '../i18n'

class ResetPasswordBox extends Component {
    static propTypes = {
    }

    _reset(event) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(sendResetPasswordCmd()).then(() => {
            return dispatch(push('/login'))
        }).then(() => {
            return dispatch(clearHistory())
        }).then(() => {
            return dispatch(infoStatus(i18n.passwordResetted))
        })
    }

    render() {
        const {dispatch, form} = this.props

        const title = (
            <h3>{i18n.resetPassword}</h3>
        )

        const help = (
            <Icon icon='key' size='xl' />
        )

        return (
            <Box
                status='info'
                header={title}
                help={help}>
                <form
                    onSubmit={(e) => this._reset(e)}>
                    <Input hasFeedback
                        type='password'
                        name='password'
                        label={i18n.password}
                        {...form.password()} />
                    <Input hasFeedback
                        type='password'
                        name='password'
                        label={i18n.confirmPassword}
                        {...form.confirmPassword()} />
                    <Button block
                        type='submit'
                        bsSize='large'
                        disabled={!form.isValid()}>
                        {i18n.send}
                    </Button>
                </form>
            </Box>
        )
    }
}

ResetPasswordBox = connectForm({
    target: 'cmd',
    schema: ResetPasswordCmd.schema,
    validator: createValidator(),
    action: RESET_PASSWORD_CMD_UPDATED
})(ResetPasswordBox)

ResetPasswordBox = connect((state) => ({
    cmd: state.user.resetPasswordCmd
}))(ResetPasswordBox)

export default ResetPasswordBox


// WEBPACK FOOTER //
// ./lib/user/components/ResetPasswordBox.js